"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Utils = require("./Utils");
var _ColorInputs = _interopRequireDefault(require("./components/ColorInputs"));
var _ColorSelector = _interopRequireDefault(require("./components/ColorSelector"));
var _EyeDropper = _interopRequireDefault(require("./components/EyeDropper"));
var _OpacitySlider = _interopRequireDefault(require("./components/OpacitySlider"));
var _SelectedColors = _interopRequireDefault(require("./components/SelectedColors"));
require("./SuperSpectrum.scss");
var _DropDownIcon = _interopRequireDefault(require("./components/Icons/DropDownIcon"));
var _CloseIcon = _interopRequireDefault(require("./components/Icons/CloseIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SuperSpectrum = function SuperSpectrum(_ref) {
  var onChange = _ref.onChange,
    currentColor = _ref.currentColor,
    layout = _ref.layout,
    hidePopup = _ref.hidePopup,
    showCloseButton = _ref.showCloseButton,
    customStyles = _ref.customStyles,
    _ref$disableTranspare = _ref.disableTransparentOption,
    disableTransparentOption = _ref$disableTranspare === void 0 ? false : _ref$disableTranspare;
  var isTransparent = currentColor === "transparent" ? true : false;
  var context;
  var ctx2;
  var context2;
  showCloseButton = showCloseButton === undefined ? false : showCloseButton;
  var MAX_RECENT_COLORS = disableTransparentOption ? 20 : 19;
  /* ------------------------------------------------------------------------
                              State Variables
  ------------------------------------------------------------------------ */
  var _useState = (0, _react.useState)(currentColor === "transparent" ? "#ff0000" : currentColor),
    _useState2 = _slicedToArray(_useState, 2),
    hexCode = _useState2[0],
    setHexCode = _useState2[1];
  var _useState3 = (0, _react.useState)(currentColor === "transparent" ? {
      r: 255,
      g: 0,
      b: 0,
      alpha: 100
    } : {
      r: 0,
      g: 0,
      b: 0,
      alpha: 100
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    rgba = _useState4[0],
    setRgba = _useState4[1];
  var _useState5 = (0, _react.useState)(layout && layout === "popup"),
    _useState6 = _slicedToArray(_useState5, 2),
    isModal = _useState6[0],
    setIsModal = _useState6[1];
  var _useState7 = (0, _react.useState)(isTransparent ? true : false),
    _useState8 = _slicedToArray(_useState7, 2),
    noColor = _useState8[0],
    setNoColor = _useState8[1];
  var _useState9 = (0, _react.useState)(localStorage.getItem("recent_colors") ? JSON.parse(localStorage.getItem("recent_colors")) : []),
    _useState10 = _slicedToArray(_useState9, 2),
    recentColors = _useState10[0],
    setRecentColors = _useState10[1];
  var _useState11 = (0, _react.useState)("hex"),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedFormat = _useState12[0],
    setSelectedFormat = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showDropdown = _useState14[0],
    setShowDropdown = _useState14[1];
  /* ------------------------------------------------------------------------
                           End of State Variables
  ------------------------------------------------------------------------ */
  var canvasRef = (0, _react.useRef)(null);
  var canvasFilledRef = (0, _react.useRef)(null);
  if (currentColor === undefined || null) {
    throw new Error("currentColor Prop is Required");
  }
  if (typeof onChange !== "function" || onChange === undefined) {
    throw new Error("onChange Handler is Required");
  }
  (0, _react.useEffect)(function () {
    if (noColor) {
      handleNoColor();
      return;
    }
    currentColor = document.querySelector(".".concat(_Utils.PREFIX_CLASSNAME, "-hidden-2")).style.backgroundColor;
    if (currentColor === "transparent") {
      currentColor = _Utils.TRANSPARENT_COLOR;
    }
    (0, _Utils.validateColorFormat)(currentColor);
    var rgb = (0, _Utils.getColorComponentFromRgbaString)(currentColor);
    currentColor = (0, _Utils.rgbToHex)(rgb[0], rgb[1], rgb[2]);
    setHexCode(currentColor.rgbString);
    context = (0, _Utils.getContext2D)(canvasRef);
    var canvas = canvasRef.current;
    var gradientH = (0, _Utils.generateHorizontalGradient)(context.createLinearGradient(1, 1, canvas.width, 1));
    context.fillStyle = gradientH;
    context.fillRect(0, 0, canvas.width, canvas.height);
    ctx2 = (0, _Utils.getContext2D)(canvasFilledRef);
    context2 = canvasFilledRef.current;
    var initialRgb = (0, _Utils.convertHexToRGBA)(currentColor.rgbString);
    (0, _Utils.generateColors)(ctx2, context2, initialRgb.rbgaString);
    var stateObj;
    if (rgb.length === 3) {
      stateObj = _objectSpread(_objectSpread({}, rgba), {}, {
        r: initialRgb.r,
        g: initialRgb.g,
        b: initialRgb.b,
        alpha: 100
      });
    } else {
      stateObj = _objectSpread(_objectSpread({}, rgba), {}, {
        r: initialRgb.r,
        g: initialRgb.g,
        b: initialRgb.b,
        alpha: rgb[3] * 100
      });
    }
    setRgba(stateObj);
    var r = initialRgb.r,
      g = initialRgb.g,
      b = initialRgb.b;
    (0, _Utils.setFilledSelectorPosition)(r, g, b, noColor);
    addRecentColors();
  }, [noColor]);
  var handlePopupButton = function handlePopupButton() {
    setIsModal(false);
  };
  (0, _react.useEffect)(function () {
    if (disableTransparentOption === false && recentColors.length === 20) {
      // remove last color
      var existingRecentColors = _toConsumableArray(recentColors);
      existingRecentColors.pop();
      setRecentColors(recentColors);
      localStorage.setItem("recent_colors", JSON.stringify(existingRecentColors));
    }
  }, [disableTransparentOption]);
  var addRecentColors = function addRecentColors() {
    var recentColorsArray = _toConsumableArray(recentColors);
    var hiddenDiv = document.querySelector(".".concat(_Utils.PREFIX_CLASSNAME, "-hidden-1"));
    if (localStorage.getItem("recent_colors") === null) {
      localStorage.setItem("recent_colors", "");
    }
    hiddenDiv.style.backgroundColor = currentColor;
    var recentColor = hiddenDiv.style.backgroundColor;
    if (recentColor === "" || recentColor === "none" || recentColor === "transparent") return;
    if (recentColorsArray.includes(recentColor)) return;
    if (recentColorsArray.length === MAX_RECENT_COLORS) {
      recentColorsArray.shift();
    }
    recentColorsArray.push(recentColor);
    setRecentColors(recentColorsArray);
    localStorage.setItem("recent_colors", JSON.stringify(recentColorsArray));
  };
  var handleOpacitySlider = function handleOpacitySlider(e) {
    var opacityValue = parseInt(e.target.value);
    setRgba(_objectSpread(_objectSpread({}, rgba), {}, {
      alpha: opacityValue
    }));
    onChange("rgba(".concat(rgba.r, ",").concat(rgba.g, ",").concat(rgba.b, ",").concat((0, _Utils.calculateOpacity)(opacityValue), ")"));
  };
  var handleFilledColorCanvas = function handleFilledColorCanvas(e) {
    var x = e.nativeEvent.offsetX;
    var y = e.nativeEvent.offsetY;
    var rgbValue = (0, _Utils.returnRgbFromCanvas)(x, y, (0, _Utils.getContext2D)(canvasFilledRef));
    var hexCode = (0, _Utils.rgbToHex)(rgbValue.r, rgbValue.g, rgbValue.b);
    setHexCode(hexCode.rgbString);
    setRgba(_objectSpread(_objectSpread({}, rgba), {}, {
      r: rgbValue.r,
      g: rgbValue.g,
      b: rgbValue.b
    }));
    (0, _Utils.setColorSelector)(x, y, "".concat(_Utils.PREFIX_CLASSNAME, "-filled-selector"));
    var finalColor = (0, _Utils.getColorComponentFromRgbaString)(rgbValue.rgbString);
    return "rgba(".concat(finalColor[0], ",").concat(finalColor[1], ",").concat(finalColor[2], ",").concat((0, _Utils.getAlphaInputValue)(), ")");
  };
  var handleRangeColorCanvas = function handleRangeColorCanvas(e) {
    var x = e.nativeEvent.offsetX;
    var y = e.nativeEvent.offsetY;
    context = (0, _Utils.getContext2D)(canvasRef);
    ctx2 = (0, _Utils.getContext2D)(canvasFilledRef);
    context2 = canvasFilledRef.current;
    var rgbValue = (0, _Utils.returnRgbFromCanvas)(x, y, context);
    var hexCode = (0, _Utils.rgbToHex)(rgbValue.r, rgbValue.g, rgbValue.b);
    setHexCode(hexCode.rgbString);
    setRgba(_objectSpread(_objectSpread({}, rgba), {}, {
      r: rgbValue.r,
      g: rgbValue.g,
      b: rgbValue.b
    }));
    (0, _Utils.generateColors)(ctx2, context2, rgbValue.rgbString);
    (0, _Utils.setColorSelector)(x, y, "".concat(_Utils.PREFIX_CLASSNAME, "-range-selector"));
    (0, _Utils.updateRangeSelectorColor)(parseInt(document.querySelector(".".concat(_Utils.PREFIX_CLASSNAME, "-range-selector")).style.left), noColor);
    var finalColor = (0, _Utils.getColorComponentFromRgbaString)(rgbValue.rgbString);
    return "rgba(".concat(finalColor[0], ",").concat(finalColor[1], ",").concat(finalColor[2], ",").concat((0, _Utils.getAlphaInputValue)(), ")");
  };
  var handleHexCodeInput = function handleHexCodeInput(e) {
    var hexCodeInputValue = e.target.value;
    var a = Number(document.getElementById("alpha").value);
    var rgbValue = (0, _Utils.convertHexToRGBA)(hexCodeInputValue, a);
    var isValidHex = (0, _Utils.validateHex)(hexCodeInputValue);
    if (hexCodeInputValue.length < 8) {
      setHexCode((0, _Utils.addHashSymbol)(hexCodeInputValue));
    }
    if (rgbValue !== null && (hexCodeInputValue.length === 4 || hexCodeInputValue.length === 7) && isValidHex) {
      setRgba(_objectSpread(_objectSpread({}, rgba), {}, {
        r: rgbValue.r,
        g: rgbValue.g,
        b: rgbValue.b,
        alpha: a
      }));
      onChange(rgbValue.rbgaString);
      ctx2 = (0, _Utils.getContext2D)(canvasFilledRef);
      context2 = canvasFilledRef.current;
      (0, _Utils.generateColors)(ctx2, context2, rgbValue.rbgaString);
      var rgb = (0, _Utils.convertHexToRGBA)(hexCodeInputValue);
      (0, _Utils.setFilledSelectorPosition)(rgb.r, rgb.g, rgb.b, noColor);
    }
  };
  var handleRGBAInput = function handleRGBAInput(e) {
    var name = e.target.name;
    var validation = (0, _Utils.textValidator)(e.target);
    var color = {};
    if (validation) {
      var r, g, b;
      if (selectedFormat === "hex") {
        var rgbValue = (0, _Utils.convertHexToRGBA)(hexCode);
        r = rgbValue.r;
        g = rgbValue.g;
        b = rgbValue.b;
      } else {
        var rInput = document.getElementById("r").value;
        var gInput = document.getElementById("g").value;
        var bInput = document.getElementById("b").value;
        r = (0, _Utils.checkRgbMinMax)(Number(rInput), 0, 255);
        g = (0, _Utils.checkRgbMinMax)(Number(gInput), 0, 255);
        b = (0, _Utils.checkRgbMinMax)(Number(bInput), 0, 255);
      }
      var alpha = (0, _Utils.checkRgbMinMax)(Number(document.getElementById("alpha").value), 0, 100);
      color.r = r;
      color.b = b;
      color.g = g;
      color.alpha = alpha;
      setRgba(_objectSpread(_objectSpread({}, rgba), {}, _defineProperty({}, name, color[name])));
      alpha = (0, _Utils.calculateOpacity)(alpha);
      onChange("rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")"));
      var hex = (0, _Utils.rgbToHex)(r, g, b);
      setHexCode(hex.rgbString);
      ctx2 = (0, _Utils.getContext2D)(canvasFilledRef);
      context2 = canvasFilledRef.current;
      (0, _Utils.generateColors)(ctx2, context2, "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")"));
      (0, _Utils.setFilledSelectorPosition)(r, g, b, noColor);
    }
  };
  var handleNoColor = function handleNoColor() {
    setNoColor(true);
    onChange("transparent");
    var filledContext = (0, _Utils.getContext2D)(canvasFilledRef);
    var rangeContext = (0, _Utils.getContext2D)(canvasRef);
    var rangeSelector = document.querySelector(".".concat(_Utils.PREFIX_CLASSNAME, "-range-selector"));
    rangeSelector.style.left = _Utils.RANGE_CANVAS_WIDTH + "px";
    filledContext.fillStyle = "#151515";
    filledContext.fillRect(0, 0, _Utils.CANVAS_WIDTH, _Utils.CANVAS_HEIGHT);
    filledContext.fillStyle = "#fff";
    filledContext.textAlign = "center";
    filledContext.font = "bold 11px";
    filledContext.fillText("No Color", _Utils.CANVAS_WIDTH / 2, _Utils.CANVAS_HEIGHT / 2);
    rangeContext.fillStyle = "#333";
    rangeContext.fillRect(0, 0, _Utils.RANGE_CANVAS_WIDTH, _Utils.RANGE_CANVAS_HEIGHT);
    (0, _Utils.updateRangeSelectorColor)(_Utils.RANGE_CANVAS_WIDTH, noColor);
  };
  var disableNoColor = function disableNoColor() {
    setNoColor(false);
    onChange(hexCode ? hexCode : "#ff0000");
  };
  var _handleSelectedColorClick = function handleSelectedColorClick(e, color) {
    disableNoColor();
    var rgbString = (0, _Utils.getColorComponentFromRgbaString)(color);
    var alpha = 100;
    if (rgbString.length > 3) {
      alpha = Math.floor(rgbString[3] * 100);
    }
    onChange("rgba(".concat(rgbString[0], ",").concat(rgbString[1], ",").concat(rgbString[2], ",").concat((0, _Utils.calculateOpacity)(alpha), ")"));
    var hex = (0, _Utils.rgbToHex)(rgbString[0], rgbString[1], rgbString[2]);
    var rgbaString = (0, _Utils.convertHexToRGBA)(hex.rgbString, alpha);
    setRgba(_objectSpread(_objectSpread({}, rgba), {}, {
      r: rgbString[0],
      g: rgbString[1],
      b: rgbString[2],
      alpha: alpha
    }));
    setHexCode(hex.rgbString);
    (0, _Utils.setFilledSelectorPosition)(rgbString[0], rgbString[1], rgbString[2], noColor);
    var ctx2 = (0, _Utils.getContext2D)(canvasFilledRef);
    var context2 = canvasFilledRef.current;
    (0, _Utils.generateColors)(ctx2, context2, rgbaString.rbgaString);
  };
  var handleFormatChange = function handleFormatChange(e, type) {
    setSelectedFormat(type);
    setShowDropdown(false);
  };
  var modalStyles = {
    position: "fixed",
    zIndex: "9999"
  };
  var closeButtonStyles = {
    gap: "11px"
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread(_objectSpread({}, customStyles), isModal ? modalStyles : {}),
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-wrapper ").concat(isModal ? "".concat(_Utils.PREFIX_CLASSNAME, "-overlay") : "".concat(_Utils.PREFIX_CLASSNAME, "-inline"))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-hidden-1"),
    style: {
      backgroundColor: currentColor
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-hidden-2"),
    style: {
      backgroundColor: currentColor
    }
  }), recentColors && recentColors.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: showCloseButton ? closeButtonStyles : {},
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-recent-colors-wrapper")
  }, /*#__PURE__*/_react.default.createElement(_SelectedColors.default, {
    selectedColors: recentColors,
    handleSelectedColorClick: function handleSelectedColorClick(e, color) {
      return _handleSelectedColorClick(e, color);
    }
  }), !disableTransparentOption && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-no-color-wrapper"),
    onClick: handleNoColor
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-no-color")
  })), isModal && showCloseButton && /*#__PURE__*/_react.default.createElement(_CloseIcon.default, {
    handleClick: handlePopupButton,
    hidePopup: hidePopup
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-color-picker ").concat(isModal ? "".concat(_Utils.PREFIX_CLASSNAME, "-overlay") : "", " ")
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-filled-canvas ").concat(noColor && "".concat(_Utils.PREFIX_CLASSNAME, "-disable"))
  }, /*#__PURE__*/_react.default.createElement("canvas", {
    style: {
      border: "".concat(noColor && "1px solid #2F3741")
    },
    onClick: function onClick(e) {
      return onChange(handleFilledColorCanvas(e));
    },
    ref: canvasFilledRef,
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-color-filled"),
    width: _Utils.CANVAS_WIDTH,
    height: _Utils.CANVAS_HEIGHT
  }), /*#__PURE__*/_react.default.createElement(_ColorSelector.default, {
    onChange: onChange,
    currentColor: currentColor,
    rgba: rgba,
    hexCode: hexCode,
    setHexCode: setHexCode,
    setRgba: setRgba,
    type: "".concat(_Utils.PREFIX_CLASSNAME, "-filled-selector"),
    canvas: canvasFilledRef,
    filledCanvasRef: canvasFilledRef,
    noColor: noColor
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-settings-wrapper")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-range-canvas ").concat(noColor && "".concat(_Utils.PREFIX_CLASSNAME, "-disable"))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-range-canvas-sliders")
  }, /*#__PURE__*/_react.default.createElement("canvas", {
    onClick: function onClick(e) {
      return onChange(handleRangeColorCanvas(e));
    },
    ref: canvasRef,
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-color-range"),
    width: _Utils.RANGE_CANVAS_WIDTH,
    height: _Utils.RANGE_CANVAS_HEIGHT
  }), /*#__PURE__*/_react.default.createElement(_ColorSelector.default, {
    onChange: onChange,
    currentColor: currentColor,
    rgba: rgba,
    hexCode: hexCode,
    setHexCode: setHexCode,
    setRgba: setRgba,
    type: "".concat(_Utils.PREFIX_CLASSNAME, "-range-selector"),
    canvas: canvasRef,
    filledCanvasRef: canvasFilledRef
  }), /*#__PURE__*/_react.default.createElement(_OpacitySlider.default, {
    noColor: noColor,
    rgba: rgba,
    handleOpacitySlider: handleOpacitySlider,
    opacityValue: rgba.alpha
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-form-wrapper")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-dropdown-wrapper-parent")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-dropdown-wrapper"),
    onClick: function onClick() {
      return setShowDropdown(!showDropdown);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-dropdown")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-color-format")
  }, selectedFormat.toUpperCase()), /*#__PURE__*/_react.default.createElement(_DropDownIcon.default, null)), showDropdown && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-dropdown-options")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-option")
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick(e) {
      return handleFormatChange(e, "rgb");
    }
  }, "RGB")), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-option")
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick(e) {
      return handleFormatChange(e, "hex");
    }
  }, "HEX")))), /*#__PURE__*/_react.default.createElement(_EyeDropper.default, {
    layout: layout,
    setIsModal: setIsModal,
    rgb: rgba,
    setRgba: setRgba,
    setHexCode: setHexCode,
    filledCanvasRef: canvasFilledRef,
    context2: canvasFilledRef.current,
    onChange: onChange,
    noColor: noColor,
    disableNoColor: disableNoColor
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-inputs-wrapper")
  }, /*#__PURE__*/_react.default.createElement(_ColorInputs.default, {
    type: selectedFormat,
    noColor: noColor,
    hexCode: hexCode,
    rgba: rgba,
    handleHexCodeInput: handleHexCodeInput,
    handleRGBAInput: handleRGBAInput
  })))))))));
};
var _default = SuperSpectrum;
exports.default = _default;